var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "credit_card"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_695_1092",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_695_1092)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "credit_card_2",
    d: "M26.875 7.58019V22.4199C26.875 22.9571 26.6834 23.4173 26.3004 23.8004C25.9173 24.1835 25.4571 24.375 24.9199 24.375H5.08016C4.54291 24.375 4.08275 24.1835 3.69966 23.8004C3.31658 23.4173 3.12504 22.9571 3.12504 22.4199V7.58019C3.12504 7.04294 3.31658 6.58277 3.69966 6.19969C4.08275 5.8166 4.54291 5.62506 5.08016 5.62506H24.9199C25.4571 5.62506 25.9173 5.8166 26.3004 6.19969C26.6834 6.58277 26.875 7.04294 26.875 7.58019ZM4.69551 10.6443H25.3045V7.58019C25.3045 7.48402 25.2644 7.39588 25.1843 7.31575C25.1042 7.2356 25.016 7.19553 24.9199 7.19553H5.08016C4.984 7.19553 4.89585 7.2356 4.81573 7.31575C4.73558 7.39588 4.69551 7.48402 4.69551 7.58019V10.6443ZM4.69551 14.157V22.4199C4.69551 22.516 4.73558 22.6042 4.81573 22.6843C4.89585 22.7645 4.984 22.8045 5.08016 22.8045H24.9199C25.016 22.8045 25.1042 22.7645 25.1843 22.6843C25.2644 22.6042 25.3045 22.516 25.3045 22.4199V14.157H4.69551Z",
    fill: "#6B7280"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit_card.7b00422b90d17e3d7b35823efbb7ddbb.svg";
export { ForwardRef as ReactComponent };